import { inject, Injectable } from '@angular/core';
import { filter, Observable } from 'rxjs';
import { Store } from '@lib.core/store/store.service';

@Injectable({providedIn: 'root'})
export class AspectViewStore {

  private readonly store = inject(Store);
  private readonly key = 'aspect-view';

  setAspectViewNameId(aspectView: string): void {
    this.store.setValue(this.key, aspectView);
  }
  
  getAspectViewNameId(): Observable<string> {
    return this.store.getValue<string>(this.key).pipe(filter((v: string | null | undefined) => v != null));
  }
}